/**
 * ItemList JSON-LD for pages whose primary content is a roster of trainers.
 *
 * The female and freelance pages are list pages competing against marketplace
 * directories, but declared nothing of the sort in their markup. This enumerates
 * the trainers actually rendered so the page describes itself as the directory
 * it is.
 *
 * Emitted as its own <script> block rather than folded into each page's existing
 * JSON-LD literal, which is a single unmaintainable 5KB template string.
 *
 * `userLocation` is already normalised to a locality by toTrainerCards (see
 * utils/trainer-card-projection), so no raw postcodes reach the markup.
 */

const SITE = "https://www.stringssg.com"

export const buildTrainerItemList = ({ pageUrl, name, trainers }) => {
    const rows = Array.isArray(trainers) ? trainers : []
    return {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "@id": `${pageUrl}#trainerlist`,
        name,
        numberOfItems: rows.length,
        itemListOrder: "https://schema.org/ItemListOrderAscending",
        itemListElement: rows.map((t, i) => {
            const fullName = [t.userFirstName, t.userLastName]
                .filter(Boolean).join(" ").trim()
            return {
                "@type": "ListItem",
                position: i + 1,
                item: {
                    "@type": "Person",
                    name: fullName || "StringsSG Trainer",
                    url: `${SITE}/profile/${t.handleName}`,
                    ...(t.profilePic ? { image: t.profilePic } : {}),
                    jobTitle: "Personal Trainer",
                    ...(t.userLocation ? {
                        address: {
                            "@type": "PostalAddress",
                            addressLocality: t.userLocation,
                            addressCountry: "SG"
                        }
                    } : {}),
                    worksFor: { "@type": "Organization", "@id": "https://www.stringssg.com/#organization", name: "StringsSG" }
                }
            }
        })
    }
}
